import { apiInstance } from "./ApiInstance";

export const getFeedbackQuestion = async () => {
  let { data = {} } = await apiInstance.get(
    `/api/questionaries/questionaries-form/feedback-form`
  );
  return data;
};
export const submitFeedback = async (payload) => {
  let { data = {} } = await apiInstance.post(
    `/api/questionaries/questionaries-form/feedback-form`,
    payload
  );
  return data;
};
